import { VALID_TOKEN, VALID_PHONE, VALID_OTP } from "@/stores/actions";

import {
  SET_VALID_TOKEN,
  SET_VALID_PHONE,
  SET_VALID_OTP,
} from "@/stores/mutations";

import { AuthServiceAPI } from "@/api/auth";

export const actions = {
  async [VALID_TOKEN]({ commit }, params) {
    try {
      let result = await AuthServiceAPI.verifyToken(params);
      if (result && result.status === 200) {
        commit(SET_VALID_TOKEN, {
          token: params.token,
        });
      }
      return result;
    } catch (e) {
      return e;
    }
  },

  async [VALID_PHONE]({ commit }, params) {
    try {
      let result = await AuthServiceAPI.verifyPhone(params);
      if (result && result.status === 200) {
        commit(SET_VALID_PHONE, {
          phone_number: params.phone_number,
        });
      }
      return result;
    } catch (e) {
      return e;
    }
  },

  async [VALID_OTP]({ commit }, params) {
    try {
      let result = await AuthServiceAPI.verifyOtp(params);
      if (result && result.status === 200) {
        commit(SET_VALID_OTP, {
          token: result.data.token,
        });
      }
      return result;
    } catch (e) {
      return e;
    }
  },
};
